<div class="mx-3 mt-0">
  <div class="dashboard-panel-head d-flex justify-content-between align-items-center ms-1">
    @if (displayHeader) {
      <h3 class="m-0">Notifications</h3>
    }
    <div class="ms-auto d-flex justify-content-end align-items-center">
      <span class="text-nowrap">Filter by:</span>
      <select aria-label="Record Type" class="form-select ms-2" [(ngModel)]="selectedCharType"
        (change)="reload()">
        @for (opt of charTypeOptions; track opt) {
          <option [value]="opt.value">{{opt.label}}</option>
        }
      </select>
      <select aria-label="Status" class="form-select ms-3" [(ngModel)]="selectedStatus" (change)="reload()">
        @for (opt of statusOptions; track opt) {
          <option [value]="opt.value">{{opt.label}}</option>
        }
      </select>
      <div class="ms-3" ngbDropdown placement="bottom-right">
        <button aria-label="Expand Menu" class="btn btn-icon btn-info hide-caret" ngbDropdownToggle
          role="button" title="Notifications Menu"><i class="fal fa-bars"></i></button>
          <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="setSelectedRead()">Mark as Read</button>
            <button ngbDropdownItem (click)="setSelectedUnread()">Mark as Unread</button>
            <button ngbDropdownItem (click)="deleteSelected()">Delete</button>
          </div>
        </div>
      </div>
    </div>
    <rl-grid [options]="gridOptions" [dataSource]="dataSource" [layoutOptions]="this.layoutOptions"
      data-cy="NotificationsRLGrid">
      <div class="text-truncate" [class.bold]="cellData.status === 'S'" *rlCellTemplate="'link_id'; let cellData">
        <a [routerLink]="linkHelper.go(cellData.charTypeId, cellData.recordId)" target="_blank"
          (click)="markAsRead(cellData)">
          <span>{{cellData.recordId}}</span>
          @if (cellData.recordRevisionId > 0) {
            <span>-{{cellData.recordRevisionId}}</span>
          }
        </a>
      </div>
      <div class="text-truncate" [class.bold]="cellData.status === 'S'" *rlCellTemplate="'link_title'; let cellData">
        <a [routerLink]="linkHelper.go(cellData.charTypeId, cellData.recordId)" target="_blank"
          (click)="markAsRead(cellData)">
          <span>{{cellData.entityTitle}}</span>
          @if (cellData.recordRevisionId > 0) {
            <span>-{{cellData.recordRevisionId}}</span>
          }
        </a>
      </div>
      <div class="text-truncate" [class.bold]="cellData.isBold" *rlCellTemplate="'bold'; let cellData"
        [style.max-width.px]="500">
        {{cellData.value}}
      </div>
      <div class="text-truncate" [class.bold]="cellData.isBold" [style.max-width.px]="750"
        *rlCellTemplate="'html'; let cellData">
        {{cellData.value | htmlToPlain}}
      </div>
      <ng-container *rlGridRowHoverOps="let rowData">
        <button class="btn btn-icon btn-info" title="View" (click)="readNotification(rowData)">
          <i class="fal fa-eye"></i>
        </button>
        <button class="btn btn-icon btn-remove" title="Delete">
          <i class="fal fa-trash-can" (click)="delete(rowData)"></i>
        </button>
      </ng-container>
    </rl-grid>
  </div>